import React, { PropsWithChildren } from 'react';

import { Close } from '@videoblocks/react-icons';

import LinkButton from '../LinkButton/LinkButton';

import './Popover.css';

type Props = {
  moreInfo: string;
  ctaLabel: string;
  ctaHref: string;
  ctaOnClick: () => void;
  onCloseClick: () => void;
  showTriangle: boolean;
  triangleOffset: string;
  trianglePosition: 'top' | 'left' | 'right';
};

function Popover(props: PropsWithChildren<Props>) {
  const {
    moreInfo = '',
    ctaLabel = '',
    ctaHref,
    ctaOnClick,
    showTriangle = false,
    onCloseClick,
    triangleOffset = '30%',
    trianglePosition,
  } = props;

  const arrowStyling = {};

  if (trianglePosition === 'top') {
    arrowStyling['left'] = triangleOffset;
  } else if (trianglePosition === 'right' || trianglePosition === 'left') {
    arrowStyling['top'] = triangleOffset;
  }

  return (
    <div className="Popover">
      {showTriangle && (
        <div
          className={'Popover-triangle' + ' ' + trianglePosition}
          style={arrowStyling}
        />
      )}

      <Close
        className="Popover-closeButton"
        onClick={onCloseClick}
        onKeyDown={onCloseClick}
        tabIndex={0}
        role="button"
      />

      <div className="Popover-primaryContent">
        {props.children}
        {ctaLabel && (
          <LinkButton
            className="text-blue-700 no-underline font-semibold"
            label={ctaLabel}
            href={ctaHref}
            onClick={ctaOnClick}
          />
        )}
      </div>
      {moreInfo && <div className="Popover-extraInfo">{moreInfo}</div>}
    </div>
  );
}

export default Popover;
